import React from 'react';
import classes from './TermsContent.module.scss';

export const TermsContent = () => {
    return (
        <div className={`${classes['content-wrapper']}`}>
            <div className={`${classes['title']}`}>Terms of Service</div>
            <p className="text-center"><strong>LEGAL</strong></p>
            <p className="text-center"><strong>TERMS OF USE</strong></p>

            <p><strong>PLEASE READ THESE TERMS OF USE BEFORE USING, OR REGISTERING TO USE, THIS WEB
                SITE AND THE SERVICE AVAILABLE THROUGH IT. THE TERMS OF USE DESCRIBE THE
                CONDITIONS OF USE AND INCLUDE DISCLAIMERS AND LIMITATIONS OF LIABILITY THAT
                AFFECT YOUR LEGAL RIGHTS. THE TERMS OF USE MAY CHANGE FROM TIME TO TIME SO
                YOU SHOULD PERIODICALLY REVIEW THESE TERMS OF USE WHEN USING THIS WEB SITE.</strong></p>
            <div className="border border-dark p-2 fw-bold">
                <p>These terms of use (the <strong>"Agreement"</strong>) are a legal agreement between you (either
                    an individual or
                    an
                    entity that you represent and/or work for, such as a company) and Fundever Market Solutions Inc.
                    (<strong>"Fundever"</strong>,<strong>"we"</strong>, <strong>"our"</strong>, or
                    <strong>"us"</strong>). By
                    clicking the “agree” button below or by registering for,
                    accessing, or using the web site located at www.fundever.com and the service available through
                    it
                    (the “Site”), including by visiting the Site, (i) you do so with the intent to electonically
                    “execute” this
                    Agreement, (ii) you agree to be bound by and comply with the terms and conditions of this
                    Agreement, and (iii) if you represent and/or work for an entity (such as a company), you declare
                    and
                    represent that you are authorized by that entity to accept this Agreement and bind that entity
                    to the
                    terms of this Agreement.</p>
                <p>Therefore, please take the time to review this Agreement carefully.</p>
                <p className="text-decoration-underline"><strong>If you do not agree with some or all of this Agreement and are not of
                    18
                    years of age or older,
                    do not register for, access, or use the Site.</strong></p>
            </div>
            <p className="text-decoration-underline"><strong>You should print a copy of this Agreement for future
                reference.</strong></p>
            <h4>USER AGREEMENT</h4>
            <p>The Site is owned and operated by Fundever. This Site is being made available to you expressly
                subject to this Agreement. The Agreement includes and incorporates the terms of our Privacy Policy
                and, if applicable, our Fee Agreement. By registering for, accessing, browsing and/or using this
                Site,
                you acknowledge that you have read, understood, and agree to be bound by the terms of this
                Agreement and to comply with all applicable laws and regulations. The terms and conditions of this
                Agreement form an essential basis of our bargain. We reserve the right to amend this Agreement at
                any time and will notify you of any such changes by posting the revised Agreement on the Site. We
                will include a “last revised” date on the Agreement as displayed on the Site. You should check
                this
                Agreement periodically for changes. All changes will be effective upon posting, unless otherwise
                provided therein. Your continued use of the Site after any change to this Agreement constitutes
                your
                agreement to be bound by any such changes. We may terminate, suspend, change, or restrict access
                to all or any part of this Site without notice or liability.</p>
            <h4>AGE AND ELIGIBILITY</h4>
            <p>Use of this Site is strictly limited to those who are 18 years of age and older. Persons under
                the age of
                18 are NOT eligible to register for, access, use, or participate on this Site.</p>
            <p>You hereby represent and warrant that, and you will use the Site only if, at the time of use,
                you:</p>
            <div className="ps-2">
                <p>a. are 18 years of age or older;</p>
                <p>b. can lawfully enter into and form contracts in accordance with applicable local laws; and</p>
                <p>c. if you are using this Site in your capacity as a mortgage broker, that you:</p>
                <div className="ps-4">
                    <p>i. are a resident of Canada and will remain as such during the term of this Agreement,</p>
                    <p>ii. are duly qualified and, if applicable, licensed, to act as a mortgage broker under
                        applicable
                        provincial, territorial and federal laws in Canada,</p>
                    <p>iii. are in compliance with all applicable laws and professional standards with respect to
                        your
                        activities as a mortgage broker and will remain as such during the term of this Agreement,</p>
                    <p>iv. are solely responsible for maintaining all registrations, memberships, and qualifications
                        related
                        to your status as a mortgage broker in the applicable jurisdictions within Canada, and you
                        will
                        maintain such registrations, memberships and qualifications in good standing during the term
                        of this Agreement, and</p>
                    <p>v. will conduct your activities on, through or in connection with the Site and your
                        relationship
                        with
                        Fundever in compliance with all applicable legislation, regulations and professional
                        standards.
                    </p>
                </div>
            </div>
            <p>Notwithstanding anything else contained herein, we reserve the right to refuse to provide access
                to
                the Site, to anyone at any time for any reason, without any notice or liability.</p>
            <h4>LIMITATIONS OF USE</h4>
            <p>The Site, including without limitation the content, text, data, design, graphics, logos, icons,
                images,
                photography, interfaces, code, software, systems, processes, services, products, features and
                tools,
                and the design, selection, arrangement and “look and feel” thereof and all intellectual property
                associated with the foregoing, other than any Information and Materials and Your Trademarks
                (collectively, the <strong>"Site Content"</strong>) is the property of or is licensed to Fundever,
                and is protected
                under
                Canadian and international copyright laws. No right, title, or interest is granted to you in the
                Site
                Content. You agree that the Site Content may not be copied, reproduced, distributed, republished,
                displayed, posted or transmitted in any form or by any means, including, but not limited to,
                electronic,
                mechanical, photocopying, recording, or otherwise, without the express prior written consent of
                Fundever. You may not modify, participate in the sale or transfer of, or create derivative works
                based
                on any Site Content, in whole or in part. The use of the Site Content on any other web site,
                including
                by linking or framing, is prohibited without Fundever’s prior written approval. You also may not,
                without Fundever’s express written permission, “mirror” any material contained on this Site on any
                other server. Any unauthorized use of any Site Content on this Site may violate copyright laws,
                trademark laws, the laws of privacy and publicity, and communications statutes and regulations.
            </p>
            <p>You may use the Site only for lawful purposes and in accordance with this Agreement. You agree
                not
                to:</p>
            <ul>
                <li>Use the Site Content or Site in any way that would constitute a violation of any applicable
                    federal, provincial, local, foreign, or international law, regulation, rule or ordinance
                    (including,
                    without limitation, any laws regarding the export of data to and from Canada or other
                    countries) or that could give rise to any civil or criminal liability;</li>
                <li>Submit false information on any application or registration you make to use the Site, or
                    otherwise that you submit to us;</li>
                <li>Post to the Site any information, records, appraisals, engineering, architectural or other
                    drawings, zoning or land use information, financials or financing information, guarantee
                    information, notes, data, borrower information, or any other information or materials about any
                    project you or anyone else posted on the Site (collectively, “Information and Materials”) that
                    are false, inaccurate, out-of-date, misleading, or incomplete;</li>
                <li>Use the Site to send, knowingly receive, upload, download, use, or reuse any material which
                    does not comply with this Agreement, or to gain unauthorized entry or access into Fundever’s
                    systems;</li>
                <li>Transmit, or procure the sending of, any advertising or promotional material without our prior
                    written consent, including any “junk mail”, “chain letter” or “spam” or any other similar
                    solicitation on the Site; and</li>
                <li>Engage in any other conduct that restricts or inhibits anyone’s use or enjoyment of the Site,
                    or
                    which, as determined by us, may harm Fundever or users of the Site or expose them to
                    liability.</li>
            </ul>
            <p>Fundever makes no claims concerning whether the Site or the Information and Materials are
                appropriate for use outside of Canada. If you access this Site from outside of the Canada, you are
                solely responsible for ensuring compliance with the laws of your specific jurisdiction.</p>
            <h4>ACCOUNT ACCESS AND SECURITY</h4>
            <p>By registering for an account on the Site, you are entirely responsible for maintaining the
                confidentiality of your account, password, and other login details. Furthermore, you are entirely
                responsible for any and all activities that occur under your account. This liability will survive
                termination of your account. You shall notify Fundever immediately of any unauthorized use of your
                account. Fundever will not be liable for any loss that you may incur as a result of someone else
                using
                your password, account, or other login details, either with or without your knowledge. However,
                you
                may be held liable for losses incurred by Fundever or another party due to someone else using your
                account, password, or other login details. You may not use anyone else’s account at any time. We
                reserve the right to terminate your account for any reason whatsoever without notice to you and
                without prejudice to other remedies that it may have. In the event that access to your account is
                terminated, Fundever shall not be liable to you or any third party for termination of your
                account.</p>
            <h4>FUNDEVER TRADEMARKS</h4>
            <p>The Fundever name and logo, Fundever.com, and all associated design and/or graphics (collectively
                the <b>“Fundever Marks”</b>) are trademarks or service marks of Fundever. Other company, product,
                and
                service names and logos used and displayed on this Site may be trademarks or service marks owned
                by Fundever or others. Nothing on this Site should be construed as granting, by implication,
                estoppel,
                or otherwise, any license or right to use any of the Fundever Marks displayed on this Site,
                without our
                prior written permission in each instance. You may not use, copy, display, distribute, modify or
                reproduce any of the trademarks or service marks found on the Site unless in accordance with
                written
                authorization by us or the holder of the trademark. We prohibit the use of any of the Fundever
                Marks
                as part of a link to or from any site unless establishment of such a link is approved in writing
                by us in
                advance. Any questions concerning any Fundever Marks, or whether any mark or logo is a Fundever
                Mark, should be referred to Fundever.</p>
            <h4>YOUR TRADEMARKS</h4>
            <p>If you upload any of your trademarks, trade names, service marks, trade dress, logos, or
                identifying
                slogans (collectively, <b>“Your Marks”</b>) to the Site, you hereby grant to Fundever a
                non-exclusive,
                fully-
                paid, royalty-free license, with the right to sublicense without consent, to use, publicly
                perform,
                publicly display, reproduce, make available, and distribute Your Marks solely on, through or in
                connection with the Site, including, without limitation, distributing Your Marks to other users of
                the
                Site.</p>
            <h4>SERVICES</h4>
            <p>Fundever connects you, as a mortgage broker, owner, developer, consortium, project sponsor, or
                lender, to other mortgage brokers, owners, developers, consortiums, project sponsors, or lenders
                for
                the purposes of obtaining financing for a third party borrower. Fundever is strictly providing an
                introduction service through the Site and a platform to assist lenders in identifying potential
                customers, to obtain information about potential projects and borrowers, and to facilitate
                projects they
                may wish to finance. If you submit information through the Site on behalf of a third party
                borrower that
                is your client, you acknowledge that you are not submitting a loan or mortgage application for
                that
                client. You acknowledge and agree that Fundever is not in any way arranging mortgages or taking
                mortgage applications, and that the sole responsibility for compliance with all applicable laws,
                regulations and professional standards in respect of any financing transactions resulting from
                introductions made on the Site, the use of the Site, or the arranging of any mortgages rests
                solely with
                you and the parties to the transaction and not with Fundever. You further agree that the
                information
                you provide to Fundever and other users of the Site will be true, accurate, current and complete.
                You
                further acknowledge that Fundever is not a mortgage broker or lender nor does it intend to become
                a
                registered mortgage broker, and that Fundever does not provide loan financing. You agree that any
                financing for a third party borrower that is your client will be pursuant to separate contractual
                arrangements that will be between that client and you, and that Fundever will not have any
                contractual
                obligations whatsoever with any third party client, or any contractual obligations with you as it
                relates
                to the financing, except with respect to any fees owed to Fundever by lenders pursuant to the
                contracts between Fundever and such lenders. Your decision to connect a third party borrower that
                is
                your client with other mortgage brokers, owners, developers, consortiums, project sponsors, and
                lenders found through the Site and any contractual relationship created thereby is solely between
                you
                and such third party client. Fundever offers no representation, warranty, or condition to any
                third party
                client with respect to any of your products or services, or that you will offer any products or
                services to
                a third party client at any specified terms or at all. Fundever further offers no representation
                or
                warranty to you that a third party borrower will accept any products or services offered by you.
                Availability, provision, and acceptance of loan financing is solely at the discretion of you and
                the third
                party borrower. Fundever has no control or influence whatsoever regarding decisions made by you or
                a third party borrower. Fundever is not responsible for any loss, damage or payment of any kind
                incurred by you or any third party borrower as a result of any discussions, relationships or other
                business dealings between you and any such third party borrower.</p>
            <h4>LINKS TO THIRDPARTY SITES</h4>
            <p>This Site may contain links to web sites controlled, owned, and operated by third parties (the
                <b>“ThirdParty Sites”</b>). Fundever cannot control and has no responsibility for the accuracy or
                availability
                of information provided on ThirdParty Sites, or the privacy and security features of those
                ThirdParty
                Sites. You acknowledge that use of any ThirdParty Sites is governed by the terms of use for those
                ThirdParty Sites, and not by this Agreement. Links to ThirdParty Sites do not constitute an
                endorsement, recommendation or adoption by Fundever of such ThirdParty Sites or the content,
                products, advertising or other materials presented on such ThirdParty Sites, but are only for your
                convenience and you access them at your own risk. Fundever will have no liability of any nature
                whatsoever for any failure of products or services offered or advertised at such Third Party Sites
                or
                otherwise.</p>
            <h4>USE AND ACCURACY OF INFORMATION</h4>
            <p>Although Fundever uses reasonable efforts to ensure that the Information and Materials contained
                on
                the Site are accurate, Fundever does not warrant or make any representation regarding the
                accuracy,
                currency or completeness of any Information and Materials provided on the Site. Information and
                Materials contained on the Site are approximate only and is subject to change at any time and in
                any
                manner whatsoever. You acknowledge and agree that Fundever is not responsible for the manner in
                which other users of the Site utilize Information and Materials you provide to Fundever or them in
                connection with the Site.</p>
            <h4>DISCLAIMER OF WARRANTIES</h4>
            <p>NONE OF FUNDEVER OR ITS RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS,
                INDEPENDENT CONTRACTORS, OR LICENSORS (COLLECTIVELY, THE “FUNDEVER GROUP”)
                GUARANTEES THE ACCURACY, ADEQUACY, TIMELINESS, CURRENCY, RELIABILITY,
                COMPLETENESS, OR USEFULNESS OF ANY OF THE SITE OR THE INFORMATION AND
                MATERIALS AND FUNDEVER DISCLAIMS LIABILITY FOR ERRORS OR OMISSIONS IN THE SITE OR
                THE INFORMATION AND MATERIALS.</p>
            <p>THIS SITE AND THE INFORMATION AND MATERIALS ARE PROVIDED “AS IS” AND “AS AVAILABLE,”
                WITHOUT ANY REPRESENTATION, WARRANTY, OR CONDITION, EITHER EXPRESS OR IMPLIED,
                INCLUDING THE IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY,
                MERCHANTABLE QUALITY, DURABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                NONINFRINGEMENT OR TITLE, OR THAT THE SITE OR THE INFORMATION AND MATERIALS WILL
                MEET YOUR EXPECTATIONS. ADDITIONALLY, THERE ARE NO WARRANTIES OR CONDITIONS AS
                TO THE RESULTS OF YOUR USE OF THE SITE OR THE INFORMATION AND MATERIALS. THE
                FUNDEVER GROUP DOES NOT WARRANT THAT THE SITE OR THE INFORMATION AND
                MATERIALS ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. THIS DOES NOT
                AFFECT THOSE WARRANTIES WHICH ARE INCAPABLE OF EXCLUSION, RESTRICTION OR
                MODIFICATION UNDER THE LAWS APPLICABLE TO THIS AGREEMENT. FUNDEVER MAY
                DISCONTINUE OR MAKE CHANGES IN THE SITE AND THE INFORMATION AND MATERIALS AT ANY
                TIME WITHOUT PRIOR NOTICE TO YOU AND WITHOUT ANY LIABILITY TO YOU. ANY DATED
                INFORMATION AND MATERIALS IS PUBLISHED AS OF ITS DATE ONLY, AND THE FUNDEVER
                GROUP DOES NOT UNDERTAKE ANY OBLIGATION OR RESPONSIBILITY TO UPDATE OR AMEND
                ANY SUCH INFORMATION AND MATERIALS. FUNDEVER RESERVES THE RIGHT TO TERMINATE
                ANY OR ALL SITE OFFERINGS OR TRANSMISSIONS WITHOUT PRIOR NOTICE TO YOU. THIS SITE
                AND THE INFORMATION AND MATERIALS COULD CONTAIN TECHNICAL INACCURACIES OR
                TYPOGRAPHICAL OR OTHER ERRORS. USE OF THIS SITE AND THE INFORMATION AND
                MATERIALS IS AT YOUR OWN RISK.</p>
            <h4>LIMITATIONS OF LIABILITY</h4>
            <p>UNDER NO CIRCUMSTANCES WILL ANY OF THE FUNDEVER GROUP BE LIABLE FOR ANY (I)
                SPECIAL, INDIRECT, INCIDENTAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES; (II)
                LOSS OF INCOME, LOST PROFITS, BUSINESS INTERRUPTION, LOST GOODWILL, LOST BUSINESS
                OPPORTUNITY, OR FAILURE TO REALIZE ANTICIPATED SAVINGS, OR (III) LOSS OR CORRUPTION
                OF DATA, CONFIDENTIAL INFORMATION, OR OTHER INFORMATION, IN THE CASE OF ALL THE
                FOREGOING ARISING OR RELATING IN ANY WAY TO THE USE OR INABILITY TO USE BY ANY
                PARTY OF THE INFORMATION AND MATERIALS, THE SITE, THE SERVICES OF THE FUNDEVER
                GROUP, OR ANY THIRD PARTY SITE TO WHICH THIS SITE IS LINKED, OR IN CONNECTION WITH
                ANY FAILURE OF PERFORMANCE, ERROR, OMISSION, INTERRUPTION, DEFECT, DELAY IN
                OPERATION OR TRANSMISSION, COMPUTER VIRUS OR LINE OR SYSTEM FAILURE, EVEN IF THE
                FUNDEVER GROUP, OR REPRESENTATIVES THEREOF, ARE ADVISED OF THE POSSIBILITY OF
                SUCH DAMAGES, LOSSES OR EXPENSES. THE FUNDEVER GROUP IS NOT LIABLE FOR ANY
                DEFAMATORY, OFFENSIVE OR ILLEGAL CONDUCT OF ANY USER. YOUR SOLE REMEDY FOR DISSATISFACTION WITH
                THIS SITE IS TO STOP USING THE SITE. IF YOUR USE OF THIS SITE OR
                INFORMATION AND MATERIALS DOWNLOADED FROM THIS SITE RESULTS IN THE NEED FOR
                SERVICING, REPAIR OR CORRECTION OF ANY SOFTWARE, EQUIPMENT, OR DATA, YOU ASSUME
                ANY COSTS THEREOF.</p>
            <p>IN NO EVENT SHALL THE AGGREGATE LIABILITY OF THE FUNDEVER GROUP TO YOU FOR ALL
                DAMAGES, LOSSES, OR CAUSES OF ACTION OF ANY KIND OR NATURE EXCEED $50.00 OR THE
                FEES (IF ANY) YOU PAID FUNDEVER IN THE 12 MONTHS PRECEDING THE CLAIM, WHICHEVER IS
                GREATER.</p>
            <p>THE ABOVE LIMITATIONS OF LIABILITY WILL APPLY TO ALL CAUSES OF ACTION AND
                REGARDLESS OF THE CAUSE OF ACTION, INCLUDING ACTIONS IN CONTRACT (INCLUDING
                FUNDAMENTAL BREACH), TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, OR ANY OTHER
                THEORY OF LIABILITY.</p>
            <h4>NO INVESTIGATION</h4>
            <p>Use of this Site involves the interaction of lenders, mortgage brokers, owners, developers,
                consortiums, project sponsors, and borrowers. Fundever merely provides a marketplace for such
                users and we will not make any attempt to verify (i) the identity, creditworthiness or ethical
                standards
                of any user, or (ii) the truth, accuracy, timeliness, or completeness of any information submitted
                by
                users on this Site. By accessing a user through this Site, Fundever does not endorse or recommend
                such user. You should take independent measures to determine the appropriateness of working with
                any user of the Site. If you believe that a user of the Site has provided false or misleading
                information,
                has acted illegally or unethically, or is abusing the Site or its purpose in any way, you should
                notify us.</p>
            <h4>INDEMNIFICATION</h4>
            <p>You agree to indemnify and hold harmless the Fundever Group from and against any and all claims,
                losses, suits, expenses, demands or liabilities, including, without limitation, legal fees and
                costs,
                incurred by the Fundever Group in connection with any claim, loss, expense or liability brought
                against or suffered or incurred by us (including any intellectual property claim) arising out of
                (i) Information and Materials, Your Marks, and any other content you submit to, upload, post to or
                transmit through the Site; (ii) a third party’s use of Information or Materials of any kind that
                you post to
                the Site; (iii) your use of the Site in violation of this Agreement or in violation of any
                applicable law,
                regulations or professional standards; (iv) your use of any products or services provided on this
                Site,
                and (v) your acts or omissions in connection with the activities contemplated by this Agreement,
                including without limitation any breach of this Agreement, or any negligence or willful misconduct
                in
                the performance of your obligations under this Agreement. Fundever may permit you, at your
                expense, to defend and control the defence of Fundever against any claim brought by a third party
                that is subject to the indemnity contained in this paragraph, in which case Fundever shall
                cooperate
                with you in the defense of the claim and you will pay such costs, damages and legal fees that a
                court
                finally awards or are included in a settlement agreed to by you, as are in proportion to your
                comparative fault in causing such amounts, provided, however, you shall not in any event settle
                any
                such claim (other than solely for monetary consideration) without the written consent of Fundever.
                Notwithstanding the foregoing, if Fundever is not satisfied that you have the ability to pay for
                the costs
                of such defence and any potential damages award, costs and legal fees of the proceeding, or if the
                defendants in any such proceeding include both Fundever and you and Fundever will have
                reasonably concluded that there may be legal defences available to it which are different from or
                additional to those available to you, then Fundever will have the right to select separate
                counsel, the
                cost of which will be at Fundever’s expense, to assert such legal defences or to otherwise
                participate
                in the defence of such action on behalf of Fundever.</p>
            <h4>MONITORING OF THE SITE</h4>
            <p>Fundever has no obligation to monitor the Site; however, you acknowledge and agree that Fundever
                has the right to monitor the Site from time to time and to disclose any information as necessary
                or
                appropriate: (i) to satisfy any law, regulation, judicial or administrative order, or governmental
                request
                for lawful access, or (ii) to protect us or other users of the Site.</p>
            <h4>CONTACT BY FUNDEVER</h4>
            <p>You agree that we may contact you by phone, fax or email. The primary purpose of contact will be
                to
                inquire about the status of a loan, but contact may also be for other purposes, such as following
                up on
                correction of technical difficulties, user preference surveys and related communications.</p>
            <h4>SUBMISSIONS TO THE SITE</h4>
            <p>Fundever does not claim any ownership rights in Information and Materials that you post on the
                Site.
                After posting your Information and Materials on the Site, you continue to retain any such rights
                that
                you may have in your Information and Materials, subject to the limited license granted by you in
                this
                Agreement. By posting any Information and Materials on the Site, you hereby grant to Fundever a
                non-exclusive, fully-paid, royalty-free license, with the right to sublicense without consent, to
                use,
                modify, delete from, add to, publicly perform, publicly display, reproduce, and distribute such
                Information and Materials solely on, through or in connection with the Site, including, without
                limitation, distributing part or all of the Information and Materials to other users of the Site.
                After you
                affirmatively delete your Information and Materials from the Site, Fundever will cease further
                distribution as soon as practicable, however; (i) Fundever will not have any ability to retrieve
                or delete
                Information and Materials that have been already downloaded by other users and shared by others
                outside of the Site; and (ii)  Fundever may retain (A) one copy thereof for legal obligation
                archival
                purposes; and (B) shadow or back-up copies which may remain within Fundever’s computer systems
                or its back-up and/or electronic archive systems until such time as such back-up copies are
                overwritten in accordance with Fundever’s document retention policies, provided such back-up
                copies
                shall not be accessed or used by anyone except as necessary and subject to the same terms and
                conditions as those contained in this Agreement.</p>
            <p>Fundever reserves the right to not publish, or to remove any Information and Materials that
                Fundever
                deems in its sole discretion, to be inappropriate for the Site, for any reason whatsoever. Nothing
                herein contained shall be construed as limiting Fundever’s responsibilities and obligations under
                its
                Privacy Policy.</p>
            <p>The Site contains Information and Materials of other users (<b>“Other Users’ Information and
                Materials”</b>) that you may access and download. You may only access, download or use any Other
                Users’ Information and Materials appearing on the Site solely for your internal business purposes.
                Except for the foregoing, you are granted no right, title, or interest in any Other Users’
                Information and
                Materials. You hereby agree that you will be solely responsible for securing any personal
                information
                received by you as part of Other Users’ Information and Materials that you download against any
                accidental or unlawful loss, access, use, or disclosure, and for compliance with any privacy
                legislation
                applicable to such personal information.</p>
            <h4>FUNDEVER DEVELOPMENTS</h4>
            <p>Fundever may create analyses, improvements, inventions, developments, computer programs,
                algorithms, processes, data, products, or services utilizing, in part, Information and Materials
                and
                information derived from your use of the Site (<b>“Fundever Developments”</b>). Fundever
                Developments
                will anonymize and aggregate information such that it is not identifiable to you or your
                operations.
                Fundever Developments, and all intellectual property rights therein, will be the sole and
                exclusive property of Fundever and may be used by Fundever for any purpose without notice or
                compensation
                to you.</p>
            <h4>REPRESENTATION AND WARRANTY</h4>
            <p>By submitting Information and Material and uploading Your Marks to the Site, you automatically
                represent and warrant that you have the full right and authority to (ii) submit such Information
                and
                Materials and upload Your Marks, including all necessary intellectual property rights and rights
                and
                consents under privacy laws, and (ii) to grant the license to such Information and Materials and
                Your
                Marks set forth in this Agreement. You are responsible for any rights clearance for any
                Information
                and Materials and Your Marks submitted or uploaded by you on the Site.</p>
            <h4>CLAIMS OF COPYRIGHT INFRINGEMENT</h4>
            <p>If you are a copyright holder and believe your work has been used on the Site in a way that
                constitutes copyright infringement, please contact our Copyright Agent with the following
                information:</p>
            <ul>
                <li>Your name, address, phone number, and email address, so that we can reach you;</li>
                <li>Identification of the copyrighted work(s) you believe to be infringed;</li>
                <li>Identification of the material on the Site you believe is infringing, including a location
                    description (e.g., a URL);</li>
                <li>A statement, made under penalty of perjury, that you are the copyright owner or are authorized
                    to act on the copyright owner’s behalf, and that the information you provided is accurate;</li>
                <li>A statement that you have a good-faith belief the disputed use is not authorized by the
                    copyright owner, its agent, or the law;</li>
                <li>A physical or electronic signature; and</li>
                <li>Send your infringement notices to Fundever Market Solutions, 900-1199 W. Hastings St.,
                    Vancouver, BC, V6E3T5</li>

            </ul>
            <h4>CONFIDENTIAL INFORMATION OF FUNDEVER</h4>
            <p>You agree to treat as proprietary and confidential, and will not use for any purpose, except in
                the strict
                performance of this Agreement, any Confidential Information of Fundever which is furnished to you
                in
                connection with your use of the Site or this Agreement. You will keep confidential all such
                Confidential
                Information in accordance with reasonable industry practices. You will only make such Confidential
                Information available to your employees, consultants, professional advisors, representatives, and
                agents on a needtoknow basis for purpose of performance of this Agreement. You covenant and
                agree that before making any such Confidential Information available to any such employees,
                consultants, professional advisors, representatives, and agents, you will ensure they are under
                obligations of confidentiality which are equivalent to or greater than those set forth in this
                Agreement.
                You will promptly cease using, and at Fundever’s request and in any event upon termination of this
                Agreement, return or destroy any and all copies of all Confidential Information in your possession
                or
                control.</p>
            <p>Fundever’s <b>“Confidential Information”</b> will include all information, whether in tangible
                form or
                otherwise, relating in any way to Fundever’s business, services, products, pricing, intellectual
                property, technology, software, trade secrets, ideas, know-how, processes, or methodologies.</p>
            <p>“Confidential Information” will not include any information which (i) was in the possession of or
                known
                by you other than from Fundever or without an obligation of confidentiality; (ii) is or becomes
                public
                knowledge other than through your fault or acts; (iii) is or becomes lawfully available to you
                from a
                third party without an obligation of confidentiality; or (iv) is required to be disclosed pursuant
                to a
                judicial or administrative process, governmental agency, law, or regulation so long as you provide
                Fundever (unless you are legally prohibited from doing so) with timely written prior notice of
                such
                required disclosure so that Fundever may review and provide comments on such proposed disclosure
                and oppose the proposed disclosure if Fundever wishes to do so.</p>
            <h4>AVAILABILITY</h4>
            <p>This Site is not intended for distribution to, or use by, any person or entity in any
                jurisdiction or country
                where such distribution or use would be contrary to applicable law or regulation. By offering this
                Site
                and Information and Materials, no distribution or solicitation is made by Fundever to any person
                to use
                the Site or Information and Materials in jurisdictions where the provision of the Site and/or
                Information
                and Materials is prohibited by law.</p>
            <h4>TERMINATION</h4>
            <p>This Agreement is effective until terminated as provided herein. Fundever may terminate this
                Agreement at any time without notice, or suspend or terminate your access and use of the Site at
                any
                time, with or without cause, in Fundever’s absolute discretion and without notice. You may
                terminate
                this Agreement at any time by permanently ceasing to use the Site and by terminating your
                registration to use the Site (if you have one). If you terminate your use of the Site and later
                use it
                again (including by visiting the Site), you will again be deemed to have agreed to the terms of
                this
                Agreement by virtue of using the Site. The following provisions of this Agreement will survive
                termination of your use or access to the Site: the sections concerning Indemnification, Disclaimer
                of
                Warranties, Limitation of Liability, Submissions to the Site, Confidential Information of
                Fundever, and
                General Provisions, and any other provision that by its terms survives termination of your use or
                access to the Site.</p>
            <h4>GENERAL PROVISIONS</h4>
            <p><span className="text-decoration-underline">Waiver</span>. Failure by Fundever to enforce any of its rights under
                this Agreement shall not be
                construed
                as a waiver of those rights or any other rights in any way whatsoever. Fundever may at any time
                and
                from time to time waive in whole or in part the benefit to it of any provision of this Agreement
                or any
                default by you, but any waiver on any occasion must be in writing to be effective and will be
                deemed
                not to be a waiver of that provision thereafter or of any subsequent default or a waiver of any
                other
                provision or default.</p>
            <p><span className="text-decoration-underline">Applicable Law and Court</span>. This Agreement and all other aspects of
                your use of the Site shall be
                governed by and construed in accordance with the laws of the province of British Columbia, and the
                federal laws of Canada applicable in British Columbia, excluding its conflict of laws rules and
                all
                private international laws that would apply a different body of law. You consent and submit to the
                exclusive jurisdiction of the Courts located in the City of Vancouver in the province of British
                Columbia
                in all disputes arising out of or relating to your use of or inability to use the services
                referenced on the
                Site and this Agreement and waive any jurisdictional or venue defenses otherwise available.
                However, you agree that nothing herein precludes Fundever’s application for injunctive remedies or
                other urgent legal relief in any jurisdiction.</p>
            <p><span className="text-decoration-underline">Force Majeure</span>. Fundever shall be excused from performance under
                this Agreement if Fundever is
                prevented, forbidden or delayed from performing, or omits to perform, any act or requirement under
                this Agreement by reason of: (a) any provision of any present or future law or regulation, (b) any
                act or
                omission of a third party, or (c) any act of God, emergency condition, war, computer or
                telecommunications or other technological failure or other circumstance beyond the control of
                Fundever.</p>
            <p><span className="text-decoration-underline">Severability</span>. If any provision of this Agreement is found to be
                invalid or unenforceable, the
                remaining
                provisions shall be enforced to the fullest extent possible, and the remaining provisions of the
                Agreement shall remain in full force and effect.</p>
            <p><span className="text-decoration-underline">Notices</span>. Fundever may provide notifications (whether required by
                law, for authorized marketing or
                business related purposes) to you via email notice or through conspicuous posting of such notice
                on
                the Site or to your account, as we may determine in our sole discretion, and shall be deemed
                received
                at the time such notice is sent or posted. You agree to notify us in the event of a change to your
                designated email address. We are not responsible for any loss of communication if you deactivate
                the
                email address you provided. All communications made pursuant to or in connection with this
                Agreement will be in English. If this Agreement is translated into a language other than English,
                the
                English version will control its interpretation.</p>
            <p><span className="text-decoration-underline">Assignment</span>. Fundever may assign or subcontract any or all of its
                rights and obligations under
                this
                Agreement at any time without your consent or notice to you. You acknowledge that you may not
                without prior written consent of Fundever, assign, transfer, rent, sublicence or lease the rights
                granted
                hereunder or delegate your obligations under this Agreement whether in part or in whole.</p>
            <p><span className="text-decoration-underline">No Partnership/Joint Venture</span>. Nothing in this Agreement shall be
                construed as forming a
                partnership
                or joint venture with you, and no third party will have the right or ability to create any
                obligation on
                Fundever’s behalf. Neither party to this Agreement will have the authority to bind the other by
                contract
                or otherwise, or make any representations on behalf of the other. Each party acknowledges that
                Fundever is acting independently from any mortgage brokers, lenders, owners, developers,
                consortiums, project sponsors, and borrowers using the Site, and that Fundever will not be deemed,
                under any circumstances, to be an employee or agent of any such mortgage broker, lender, owner,
                developer, consortium, project sponsor, borrower, or any of their affiliates for any purpose.</p>
            <p><span className="text-decoration-underline">Entire Agreement</span>. This Agreement (including the incorporated
                Privacy Policy and, if applicable,
                Fee
                Agreement) supersedes any previous Terms of Use Agreement posted on the Site to which you and
                Fundever may have been bound. Notwithstanding any other terms contained herein, the parties
                expressly acknowledge that this Agreement constitutes the entire agreement between you and
                Fundever. Neither the course of conduct between parties nor trade practice shall act to modify any
                provision of the Agreement. All rights not expressly granted herein are hereby reserved.</p>
            <p><span className="text-decoration-underline">Interpretation</span>. The headings of clauses contained in this
                Agreement preceding the text of the
                sections, subsections and paragraphs hereof are inserted solely for convenience and ease of
                reference only and shall not constitute any part of this Agreement, or have any effect on its
                interpretation or construction. All references in this Agreement to the singular shall include the
                plural
                where applicable.</p>
            <p><span className="text-decoration-underline">Remedies not Exclusive</span>. The remedies provided to the parties under
                this Agreement are cumulative
                and not exclusive to each other, and any such remedy will not be deemed or construed to affect any
                right which any of the parties is entitled to seek at law, in equity or by statute.</p>
            <p><span className="text-decoration-underline">Enurement</span>. This Agreement will be binding on, inure to the benefit
                of, and be enforceable against
                the
                parties and their respective successors, assigns, heirs, and personal representatives.</p>
            <h4>CONTACTING FUNDEVER</h4>
            <p>If you have questions regarding the Agreement or the practices of Fundever, please contact us by
                email at <a href="mailto:contact@Fundever.com">contact@Fundever.com</a>. Fundever is an assumed
                business name of Fundever Market
                Solutions, Inc., a BC corporation.</p>
            <p>&#169;Fundever Market Solutions, Inc. 2016-2020</p>
            <p>Last Updated: August 20th, 2020</p>
        </div>
    );
};